/* Decottaa teması – ürün sayfasında sabit "Sepete Ekle" çubuğu: sayfa açılınca (always) ya da asıl düğme geçilince (after). */
(() => {
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'after') {
        this.toggle(true);
        return;
      }
      const info = this.closest('[data-product-info]');
      this.target = info && info.querySelector('.buy-block');
      if (!this.target) return;
      // Hızlı kaydırmada düğme ekrandan hiç geçmeyebilir; bu yüzden konum her kaydırmada ölçülür
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.toggle(this.target.getBoundingClientRect().bottom < 0);
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
      cancelAnimationFrame(this.frame);
      document.body.classList.remove('has-sticky-atc');
    }

    toggle(visible) {
      if (visible === this.visible) return;
      this.visible = visible;
      this.classList.toggle('is-visible', visible);
      this.inert = !visible;
      document.body.classList.toggle('has-sticky-atc', visible);
    }
  }
  if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc);
})();
